$(document).ready(function() {

  if ($("#rounds-accordion").length || $("#participants-accordion").length) {
    $('.score-edit').hide();
    $(".toggle-edit").click(function() {
      $(this).parents(".display-score-edit").first().children('.score-display').hide();
      $(this).parents(".display-score-edit").first().children('.score-edit').show();
    });
  }
});
